import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { GET_STATS_URL, DONATION_GOAL_DUCKS } from "../data/EventConfig";

const Wrap = styled.div`
  width: min(100%, 560px);
  margin: 1.5rem auto 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(10, 42, 74, 0.08);
  border-radius: 18px;
  padding: 1.1rem 1.25rem;
  box-shadow: 0 12px 28px rgba(10, 42, 74, 0.1);
  position: relative;
  z-index: 5;
`;

const Top = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.7rem;
`;

const HeadLine = styled.div`
  color: #0a2a4a;
  font-weight: 800;
  font-size: clamp(1.05rem, 2.5vw, 1.3rem);
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;

  span.num {
    color: #faa71e;
    font-size: clamp(1.25rem, 3vw, 1.55rem);
  }
`;

const Goal = styled.div`
  color: rgba(10, 42, 74, 0.7);
  font-size: 0.85rem;
  font-weight: 600;
`;

const BarOuter = styled.div`
  background: rgba(10, 42, 74, 0.08);
  border-radius: 999px;
  height: 12px;
  overflow: hidden;
  margin-bottom: 0.6rem;
`;

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(100% + 200px) 0; }
`;

const BarInner = styled.div`
  height: 100%;
  width: ${({ $pct }) => `${$pct}%`};
  background: linear-gradient(90deg, #ffce2d 0%, #faa71e 50%, #ffce2d 100%);
  background-size: 200px 100%;
  animation: ${shimmer} 2.4s linear infinite;
  border-radius: 999px;
  transition: width 0.8s cubic-bezier(0.22, 0.61, 0.36, 1);
  min-width: ${({ $pct }) => ($pct > 0 ? "12px" : "0")};
`;

const Bottom = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.35rem;
  font-size: 0.88rem;
`;

const Pct = styled.span`
  color: #0a2a4a;
  font-weight: 800;
`;

const Money = styled.span`
  color: rgba(10, 42, 74, 0.78);
  font-weight: 600;

  strong {
    color: #0a2a4a;
    font-weight: 800;
  }
`;

const fmt = (n) => new Intl.NumberFormat("ro-RO").format(n);

const POLL_MS = 30000;

const DonationProgress = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!GET_STATS_URL) return undefined;
    let cancelled = false;
    const fetchStats = async () => {
      try {
        const r = await fetch(GET_STATS_URL);
        if (!r.ok) throw new Error("bad status");
        const d = await r.json();
        if (!cancelled) setStats(d);
      } catch {
        // swallow — we just leave the previous state
      }
    };
    fetchStats();
    const id = setInterval(fetchStats, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  // Hide entirely if backend isn't reachable yet — better than showing zeros.
  if (!stats) return null;

  const { totalDucks = 0, ronRaised = 0, goal = DONATION_GOAL_DUCKS, percent = 0 } = stats;

  return (
    <Wrap>
      <Top>
        <HeadLine>
          <span aria-hidden>🐥</span>
          <span className="num">{fmt(totalDucks)}</span>
          rățuște adoptate
        </HeadLine>
        <Goal>din obiectivul de {fmt(goal)}</Goal>
      </Top>
      <BarOuter>
        <BarInner $pct={Math.max(0, Math.min(100, percent))} />
      </BarOuter>
      <Bottom>
        <Pct>{percent.toFixed(percent < 10 ? 1 : 0)}%</Pct>
        <Money>
          <strong>{fmt(ronRaised)} RON</strong> fonduri strânse
        </Money>
      </Bottom>
    </Wrap>
  );
};

export default DonationProgress;
